import {
  CategoryApiData,
  CategoryResponse,
  CategoryTableData,
  CategoryTableRow,
} from '@app/models/post_categories/CategoryResponse';
import { post, get } from './http.api';
import deleteRequest from './http.api';
import { Parameters } from '@app/models/Parameters';
import { CategoryRequest } from '@app/models/post_categories/CategoryRequest';
import { notification } from 'antd';
import axios from 'axios';

export const getCategoryTableData = async (parameters: Parameters): Promise<CategoryTableData> => {
  try {
    const { data, status } = await get<any>('post_categories', { params: parameters }, true);
    console.log(`Status: ${status}`, `Data:`, data);

    const categories: CategoryTableRow[] = data?.post_categories?.data?.map((categoryData: any) => ({
      id: categoryData.id,
      name: categoryData.name,
      slug: categoryData.slug,
      description: categoryData.description,
      status: categoryData.status,
      parent: categoryData.parent_id,
    }));

    return {
      data: categories,
      status_options: Array.isArray(data.status_options) ? data.status_options : [],
      pagination: {
        current: data.post_categories.current_page,
        pageSize: data.post_categories.per_page,
        total: data.post_categories.total,
      },
    };
  } catch (error: any) {
    console.error('Error fetching Post Categories:', error);
    throw error;
  }
};

export const getAllCategories = async (): Promise<CategoryResponse> => {
  try {
    const { data, status } = await get<CategoryResponse>('post_categories', undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getCategoryById = async (id: number): Promise<CategoryResponse> => {
  try {
    const { data, status } = await get<CategoryResponse>(`post_categories/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const storeCategory = async (categoryData: CategoryRequest) => {
  try {
    const response = await post<any>('post_categories/create', categoryData, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const createCategory = async (): Promise<CategoryApiData> => {
  try {
    const { data, status } = await get<CategoryApiData>('post_categories/create', undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const showCategory = async (id: number) => {
  try {
    const { data, status } = await get<CategoryApiData>(`post_categories/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const editCategory = async (id: number) => {
  try {
    const { data, status } = await get<CategoryApiData>(`post_categories/${id}/edit`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const updateCategory = async (id: number, updateData: CategoryRequest) => {
  try {
    const { data, status } = await post<CategoryRequest>(`post_categories/${id}/edit`, updateData, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const deletePostCategory = async (id: number) => {
  try {
    const { data, status } = await post<any>(`post_categories/${id}`, { _method: 'DELETE' }, undefined, true);

    console.log(`Status: ${status}`, `Data:`, data);
    return data;
  } catch (error: any) {
    console.error('Error deleting Post:', error);
    throw error;
  }
};
